export class UpdateEmisorEnvironment {
   emisorId: string;
   usuarioId: string;
   ambienteId: number;
}
